'use strict';

module.exports = function (angularModule) {
  angularModule
      .constant('REF_DATA_API_BASE', '/ref-data/webapi')
      .service('refDataApiFactory', require('./refDataApiFactory'));
};



//////////////////
// WEBPACK FOOTER
// /app/~/redi-refdata-web-lib/dist/infrastructure/index.js
// module id = 130
// module chunks = 0